import module from 'finanzas/module.js'
import template from './template.html'

function FinanzasClasificarmovimientosIndividualArchivosComponent ($fileSystem, $notify, FinanzasClasificarMovimientos) {
  var $ctrl = this;
  $ctrl.$onInit = $onInit;
  $ctrl.seleccionar = seleccionar;

  function $onInit () {
    $ctrl.analizando = false;
    $ctrl.accept = 'application/pdf,text/plain';
  }

  function analizar (files) {
    $ctrl.analizando = true;
    $ctrl.files = files;
    var nombres = [];

    $ctrl.files.forEach(function (item) {
      nombres.push(formarObjeto(item.name));
    });

    if (nombres.length > 0)
      FinanzasClasificarMovimientos.getCoindicencias(nombres, $ctrl.cuenta).then(function (response) {
        $ctrl.onChange({$event: {data: response.data}});
        $ctrl.analizando = false;
      });
  }

  function formarObjeto (item) {
    try {
      var array = item.split('-');
      return {
        fecha: array[0] + '-' + array[1] + '-' + array[2],
        idNomina: array[3],
        nombre: array[4],
        monto: parseFloat(getMonto(array[6])),
        archivo: item,
      };
    } catch ($e) {
      $ctrl.analizando = false;
      $notify.error('Uno de los archivos no tiene el formato correcto para ser analizado');
    }
  }

  function getMonto (item) {
    return item.replace(/[^\d.-]/g, '').replace(/^([^.]*\.)(.*)$/, function (a, b, c) {
      return b + c.replace(/\./g, '');
    });
  }

  function seleccionar () {
    $fileSystem.select(true, $ctrl.accept)
      .then(analizar);
  }
}

module.component('finanzasClasificarmovimientosIndividualArchivos', {
  controller: FinanzasClasificarmovimientosIndividualArchivosComponent,
  template,
  bindings: {
    onChange: '&',
    cuenta: '<',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/_/clasificarmovimientos/components/individual/archivos/component.js